var map = {
	"./en-US/Companies-Import-Framework.csv": 50518,
	"./en-US/Companies-Import-Framework.xlsx": 51218,
	"./esp/Modelo-Importacion-Empresas.csv": 41458,
	"./esp/Modelo-Importacion-Empresas.xlsx": 14790,
	"./pt-BR/Modelo-Importacao-Empresas.csv": 64572,
	"./pt-BR/Modelo-Importacao-Empresas.xlsx": 97031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85110;